import React from 'react';
import { Link } from 'react-router-dom';

export const Footer = () => (
  <footer className="footer">
    <div className="footer-inner">
      <div className="fbrand-row">
        <img src="/images/hmtlogogreen.png" alt="" className="flogo" />
        <div>
          <div className="fbrand">Hakuna Matata Technologies LLC</div>
          <div className="fnote">No worries, just solutions.</div>
        </div>
      </div>
      <nav aria-label="Footer">
        <Link to="/#work">Services</Link>
        <Link to="/pricing">Rate card</Link>
        <Link to="/#contact">Contact</Link>
      </nav>
      <div className="fnote">© {new Date().getFullYear()} · NYC &amp; Northern NJ</div>
    </div>
  </footer>
);
